
/* styles */
require("!!../../../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../vue-loader/lib/style-rewriter?id=data-v-58ee5e1d&scoped=true!../../../../vue-loader/lib/selector?type=styles&index=0!./BreedingRhombusSpinner.vue")

var Component = require("!../../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../vue-loader/lib/selector?type=script&index=0!./BreedingRhombusSpinner.vue"),
  /* template */
  require("!!../../../../vue-loader/lib/template-compiler?id=data-v-58ee5e1d!../../../../vue-loader/lib/selector?type=template&index=0!./BreedingRhombusSpinner.vue"),
  /* scopeId */
  "data-v-58ee5e1d",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/epic-spinners/src/components/lib/BreedingRhombusSpinner.vue
// module id = 858
// module chunks = 1